import { c as _c } from "react/compiler-runtime";
import { Fragment } from 'react';
import type { Option } from '@/types';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator } from '@/components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';
interface DataTableFacetedFilterProps extends React.ComponentProps<'button'> {
  title?: string;
  options: Option[];
  filterValue: Record<string, boolean>;
  onFilterChange: (arg: Record<string, boolean>) => void;
}
const numberFormat = new Intl.NumberFormat('en');
export function DataTableFacetedFilter(t0) {
  const $ = _c(40);
  const {
    title,
    filterValue,
    onFilterChange,
    options,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== filterValue) {
    t2 = Object.values(filterValue).filter(Boolean);
    $[0] = filterValue;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const selected = t2;
  let t3;
  if ($[2] !== className) {
    t3 = cn("h-8 gap-0 border-dashed p-0 text-xs shadow-none drop-shadow-none!", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== title) {
    t4 = <div className="inline-flex h-full items-center justify-center space-x-[2.5px] px-1.5 has-[>*:nth-child(2)]:pl-[5.5px]"><span className="">{title}</span></div>;
    $[4] = title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== filterValue || $[7] !== options || $[8] !== selected.length) {
    t5 = selected.length > 0 && <Fragment><Separator orientation="vertical" className="h-4" /><div className="flex space-x-1 px-1 lg:hidden"><Badge variant="secondary" className="px-1 font-normal [--sq-r:.5625rem]">{selected.length}</Badge></div><div className="hidden space-x-1 px-1 lg:flex">{selected.length >= 2 ? <Badge variant="secondary" className="px-1 font-normal [--sq-r:.5625rem]">{selected.length}</Badge> : options.filter(option => filterValue[option.value]).map(_temp)}</div></Fragment>;
    $[6] = filterValue;
    $[7] = options;
    $[8] = selected.length;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <Fragment>{t4}{t5}</Fragment>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <PopoverTrigger render={<Button variant="outline" size="sm" className={t3}>{t6}</Button>} />;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== title) {
    t8 = <CommandInput placeholder={title} />;
    $[16] = title;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CommandEmpty>No results found.</CommandEmpty>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== filterValue || $[20] !== onFilterChange || $[21] !== options) {
    let t11;
    if ($[23] !== filterValue || $[24] !== onFilterChange) {
      t11 = option_1 => {
        const isSelected = Boolean(filterValue[option_1.value]);
        return <CommandItem key={option_1.value} onSelect={() => {
          if (isSelected) {
            onFilterChange({
              ...filterValue,
              [option_1.value]: false
            });
          } else {
            onFilterChange({
              ...filterValue,
              [option_1.value]: true
            });
          }
        }} className="gap-2"><div className={cn("flex size-4 items-center justify-center border-primary", isSelected ? "" : "opacity-50")}><Checkbox checked={isSelected} className="cursor-default **:data-[slot=check-icon]:size-3.5" /></div>{option_1.icon ? <option_1.icon className="size-4 text-muted-foreground" /> : null}<span>{option_1.label}</span>{option_1.count ? <span className="ml-auto flex size-4 items-center justify-end text-xs tracking-[0.0625em] tabular-nums">{numberFormat.format(option_1.count)}</span> : null}</CommandItem>;
      };
      $[23] = filterValue;
      $[24] = onFilterChange;
      $[25] = t11;
    } else {
      t11 = $[25];
    }
    t10 = options.map(t11);
    $[19] = filterValue;
    $[20] = onFilterChange;
    $[21] = options;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[26] !== t10) {
    t11 = <CommandGroup className="max-h-75 overflow-x-hidden overflow-y-auto">{t10}</CommandGroup>;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== filterValue || $[29] !== onFilterChange) {
    t12 = Object.values(filterValue).some(Boolean) && <Fragment><CommandSeparator /><CommandGroup><CommandItem onSelect={() => onFilterChange({})} className="justify-center text-center">Clear filters</CommandItem></CommandGroup></Fragment>;
    $[28] = filterValue;
    $[29] = onFilterChange;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t11 || $[32] !== t12) {
    t13 = <CommandList className="max-h-full">{t9}{t11}{t12}</CommandList>;
    $[31] = t11;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t13 || $[35] !== t8) {
    t14 = <PopoverContent className="w-50 p-0" align="start"><Command className="rounded-none bg-transparent">{t8}{t13}</Command></PopoverContent>;
    $[34] = t13;
    $[35] = t8;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t14 || $[38] !== t7) {
    t15 = <Popover>{t7}{t14}</Popover>;
    $[37] = t14;
    $[38] = t7;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
}
function _temp(option_0) {
  return <Badge variant="secondary" key={option_0.value} className="px-1 font-normal [--sq-r:.5625rem]">{option_0.label}</Badge>;
}